export default __webpack_public_path__ + "assets/images/android-chrome-192x192.png";